import { FC, useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useGetClientActivityById } from "../../../../../../api/services/client/clientApis";
import { UnitTypesKey } from "../../../../../../helpers/constants/siteCoreKeys";
import {
  convertLocalizeObjToFormValue,
  isNotEmpty,
} from "../../../../../../helpers/utils";
import { useSiteCore } from "../../../../../../hooks/useSiteCore";
import { toggleToast } from "../../../../../../redux/slices/appState/appStateSlice";
import { KeyValueMap } from "../../../../../../redux/slices/appState/models";
import {
  CreateActivityDefaultFormKeys,
  CreateActivityGeneralFormKeys,
  CreateClientActivitiesRowValue,
  EditActivityValueProps,
} from "../../modelsAndSchemas/models";
import { CreateActivity } from "../createActivity/CreateActivity";

interface EditActivityProps {
  handleCloseModal: () => void;
  pageId: string;
  show: boolean;
  selectedActivity: CreateClientActivitiesRowValue;
  getListOfActivitiesApi: () => void;
}
export const EditActivity: FC<EditActivityProps> = ({
  selectedActivity,
  show,
  pageId,
  handleCloseModal,
  getListOfActivitiesApi,
}) => {
  const dispatch = useDispatch();
  const { commonLabels } = useSiteCore();
  const [activityValue, setActivityValues] = useState<EditActivityValueProps>();
  const {
    data: clientActivityData,
    isFetching: isPending,
    isError: isTemplateActivityError,
  } = useGetClientActivityById(selectedActivity.id);

  useEffect(() => {
    if (isTemplateActivityError) {
      dispatch(
        toggleToast({
          open: true,
          message: commonLabels.someThingWentWrongPleaseTryAgainLater,
          type: "error",
        }),
      );
    }
  }, [isTemplateActivityError]);

  useEffect(() => {
    if (isNotEmpty(clientActivityData)) {
      const defaultValues = {
        [CreateActivityGeneralFormKeys.candidateStatuses]:
          clientActivityData?.candidateStatuses ?? "",
        [CreateActivityGeneralFormKeys.activityType]:
          clientActivityData?.activityType ?? "",
        [CreateActivityGeneralFormKeys.modality]:
          clientActivityData?.modalities ?? "",
        [CreateActivityGeneralFormKeys.topic]: convertLocalizeObjToFormValue(
          clientActivityData.localizedTopicNames ?? [],
        ),
        [CreateActivityGeneralFormKeys.deliverables]:
          clientActivityData?.deliverables?.map((item: KeyValueMap) => item.id),
        [CreateActivityGeneralFormKeys.activityStatus]:
          clientActivityData?.activityStatus ?? "",
        [CreateActivityGeneralFormKeys.triggerBilling]:
          clientActivityData?.triggerBilling ?? false,
        [CreateActivityGeneralFormKeys.lastContactDate]:
          clientActivityData?.countsTowardsLastContactDate ?? false,
        [CreateActivityGeneralFormKeys.triggerTouch]:
          clientActivityData?.triggerTouchPointSurvey ?? false,
        [CreateActivityDefaultFormKeys.units]: clientActivityData.units ?? "",
        [CreateActivityDefaultFormKeys.measurementMinute]:
          clientActivityData?.units === UnitTypesKey.Minutes
            ? clientActivityData.measurement
            : "",
        [CreateActivityDefaultFormKeys.measurementOther]:
          clientActivityData?.units === UnitTypesKey.Days ||
          clientActivityData?.units === UnitTypesKey.Count
            ? clientActivityData.measurement
            : undefined,
      };
      setActivityValues(defaultValues);
    }
  }, [clientActivityData]);

  return (
    <CreateActivity
      show={show}
      handleCloseModal={handleCloseModal}
      pageId={pageId}
      getListOfActivitiesApi={getListOfActivitiesApi}
      isEditActivity={true}
      editActivityData={activityValue}
      isPendingActivity={isPending}
      selectedActivity={selectedActivity}
    />
  );
};
